import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=2ef6cda8&scoped=true&"
import script from "./Pagination.vue?vue&type=script&lang=js&"
export * from "./Pagination.vue?vue&type=script&lang=js&"
import style0 from "./custom-grid.css?vue&type=style&index=0&id=2ef6cda8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef6cda8",
  null
  
)

export default component.exports